import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  flex: {
    display: "flex",
  },
  spaceBw: {
    justifyContent: "space-between",
  },
  alignCenter: {
    alignItems: "center",
  },
  alignBase: {
    alignItems: "baseline",
  },
  sportsContainer: {
    maxWidth: "1440px",
    margin: "0 auto",
    padding: "172px 120px 48px 120px",
    fontFamily: "'Inter', sans-serif",
    color: "#212121",
  },

  sportsHeading: {
    fontSize: "2rem",
    fontWeight: 700,
    color: "#424242",
    lineHeight: "44px",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.4rem",
      lineHeight: "32px",
    },
  },
  sportsSubheading: {
    fontSize: "1.7rem",
    color: "#424242",
    fontWeight: 600,
    lineHeight: "36px",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
  },

  sportsPara: {
    fontSize: "1.2rem",
    color: "#424242",
    fontWeight: "500",
    // maxWidth: "800px",
    margin: "0 auto 2rem auto",
    lineHeight: 1.6,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
    },
  },

  sportsSectionHeading: {
    fontSize: "1.4rem",
    fontWeight: 700,
    color: "#424242",
    // textAlign: "center",
    marginBottom: "0.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
  },

  sportsSectionPara: {
    // textAlign: "center",
    color: "#424242",
    fontSize: "1.2rem",
    fontWeight: "500",
    // maxWidth: "750px",
    margin: "0 auto 2rem auto",
    lineHeight: 1.6,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
    },
  },

  venueGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "2rem",
    margin: "2rem 0",
    [theme.breakpoints.down("lg")]: {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },

  venueCard: {
    display: "block",
    position: "relative",
    borderRadius: "12px",
    // overflow: "hidden",
    textDecoration: "none",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    // transition: "transform 0.2s ease, box-shadow 0.2s ease",
    background: "#fff",
    "&:hover": {
      // transform: "translateY(-4px)",
      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.12)",
    },
  },

  venueImage: {
    width: "100%",
    height: "180px",
    objectFit: "cover",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    [theme.breakpoints.down("sm")]: {
      height: "140px",
    },
  },

  venueInfo: {
    padding: "0.75rem 1rem",
    // textAlign: "center",
  },

  venueName: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#424242",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
    },
  },

  faqSection: {
    marginTop: "3rem",
  },

  faqTitle: {
    fontSize: "1.7rem",
    fontWeight: 700,
    color: "#424242",
    // textAlign: "center",
    margin: "4rem 0rem 2.5rem 0rem",
  },

  faqList: {
    listStyle: "none",
    padding: 0,
    // maxWidth: "850px",
    margin: "0 auto",
  },

  faqItem: {
    marginBottom: "1.2rem",
    borderBottom: "1px solid #eee",
    paddingBottom: "1rem",
  },

  faqQuestion: {
    fontWeight: 700,
    color: "#424242",
    fontSize: "1.5rem",
    marginBottom: "0.5rem",
  },

  faqAnswer: {
    color: "#424242",
    fontWeight: "400",
    lineHeight: 1.6,
    fontSize: "1.2rem",
  },
  price: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#212121",
    fontStyle:"normal",
  },
  timeIcon: {
    marginRight: "4px",
  },
  forwardArrow: {
    position: "absolute",
    bottom: "-14px", 
    right: "12px",
    backgroundColor: "#fff",
    width: "auto",
    height: "auto",
    padding:"6px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.12), 0 8px 20px rgba(0, 0, 0, 0.15)",
    cursor: "pointer",
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
    "& svg": {
        width:"20px",
        height:"20px",
        stroke:"#ff4e00"
    }
  },
  "@media (max-width: 1050px)": {
    venueGrid: {
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "1.5rem",
    },
    sportsContainer: {
      padding: "148px 60px 60px 60px",
    },
  },

  "@media (max-width: 550px)": {
    sportsContainer: {
      padding: "82px 16px 16px 16px",
    },
    sportsSubheading: {
      lineHeight: "24px",
    },
    venueGrid: {
      gridTemplateColumns: "repeat(1, 1fr)",
      gap: "2.5rem",
    },
    venueImage: {
      height: "210px",
    },
    faqTitle: {
      fontSize: "1.2rem",
      margin: "2rem 0rem",
    },
    faqQuestion: {
      fontSize: "1rem",
    },
    faqAnswer: {
      fontSize: "1rem",
    },
  },
}));

export default useStyles;
